import axios from "axios";
import { handleMsalTokenExpired, isMsalTokenExpiredError } from "./authSession";

const SECURITY_APP_BACKEND_URL = process.env.REACT_APP_SECURITY_APP_BACKEND_URL;

export const apiCall = async (method, body, path, token, params = null) => {

    const headers = token ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    } : null;

    const config = {
        method: method,
        url: `${SECURITY_APP_BACKEND_URL}/${path}`,
        headers: {
            ...headers,
        },
        data: body,
        params: params,
    };

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        const response = error.response;

        if (isMsalTokenExpiredError(response)) {
            handleMsalTokenExpired();
        }

        return response;
    }

}
